<template>
    <div>
    <v-btn color="primary" dark class="my-2" @click="dialog_add=true">Add Course Assistant</v-btn>
    <v-dialog v-model="dialog_add" class="w-full md:w-1/2">
                <v-card>
                    <v-card-title>
                        <span class="headline">Add Course Assistant:</span>
                        <v-spacer></v-spacer>
                        <v-divider vertical class="mx-4"></v-divider>
                        <v-icon @click="close_add">mdi-close</v-icon>
                    </v-card-title>
                    <v-divider></v-divider>
                        <div v-if="validationErrors">
			<v-alert density="compact" type="error" title="Validation Errors">
                            <ul>
                                <li v-for="(value, key, index) in validationErrors">{{ value }}</li>
                            </ul>
		        </v-alert>
                        </div>
                    <v-divider></v-divider>
                    <v-card-text>
    
                <div class="px-2">
                                <div class="flex flex-wrap justify-start content-center -mx-2 p-8">
    
				<div class="w-full md:w-1/1 px-2 mt-5">
                                   <v-select v-model="addedItem.term_cd" prepend-inner-icon="calendar_month" chips
                                                  :items="semesters" clearable
                                                  label="Semester" autofocus outlined>
                                   </v-select>
                                </div>	

                                    <div class="w-full md:w-1/1 px-2 mb-5">

<v-autocomplete v-if="addedItem.term_cd != ''" v-model="addedItem.crn" :items="crns" :loading="loadingData"
                        :search-input.sync="searchcrn" hide-no-data item-text="crs_pretty_name" item-value="crn" class="mt-5"
                        :placeholder="addedItem.crn" prepend-inner-icon="library_books" hint="Start typing course info to search for course" persistent-hint
                        clearable outlined placeholder="Course(s)" multiple chips>
</v-autocomplete>

                                    </div>
                                    <div class="w-full md:w-1/1 px-2 mb-5">
<v-autocomplete v-if="addedItem.crn != ''" v-model="addedItem.uin" :items="uins" :loading="loadingData"
                        :search-input.sync="searchuin" hide-no-data item-text="full_name" item-value="uin" chips
                        :placeholder="addedItem.uin" prepend-inner-icon="person_add" hint="Start typing a last name/netid to search for a user" persistent-hint
                        clearable outlined placeholder="User">
               
                    <template v-slot:item="{ item }">
                        <v-list-item-avatar color="indigo" class="headline font-weight-light white--text">
                            {{ item.full_name.charAt(0) }}
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title v-text="item.uin"></v-list-item-title>
                            <v-list-item-subtitle v-text="item.full_name"></v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
</v-autocomplete>
                                    </div>

<div class="w-full md:w-1/1 px-2">
    <v-btn v-if="addedItem.uin != ''"  @click="dialog_help=true"
      color="info">
      <v-icon>mdi-help-circle-outline</v-icon></v-btn>
</div>

				<div class="w-full md:w-1/1 px-2">
                                   <v-select v-if="addedItem.uin != ''" v-model="addedItem.role"
                                                  :items="roles" chips clearable
                                                  label="Role" outlined>
                                   </v-select>
                                </div>	

				<div class="w-full md:w-5/5 px-2">
                                    <v-textarea v-if="addedItem.uin != ''" required
                                        v-model="addedItem.reason" required outlined rows="3" prepend-inner-icon="article"
                                        label="Reason" clearable>
                                    </v-textarea>
                                </div>

                                </div>
                </div>
    
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :loading="loadingStore" color="blue darken-1" @click="store(addedItem)">Save</v-btn>
                        <v-btn outlined color="error" @click="close_add">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
    
    <v-dialog v-model="dialog_update" class="w-full md:w-1/2">
                <v-card>
                    <v-card-title>
                        <span class="headline">Update Course Assistant:</span>
                        <v-spacer></v-spacer>
                        <v-divider vertical class="mx-4"></v-divider>
                        <v-icon @click="close_update">mdi-close</v-icon>
                    </v-card-title>
                    <v-divider></v-divider>
                        <div v-if="validationErrors">
			<v-alert density="compact" type="error" title="Validation Errors">
                            <ul>
                                <li v-for="(value, key, index) in validationErrors">{{ value }}</li>
                            </ul>
		        </v-alert>
                        </div>
                    <v-divider></v-divider>
                    <v-card-text>
    
                            <div class="px-2">
                                <div class="flex flex-wrap justify-start content-center -mx-2 p-8">
    
                                    <div class="w-full md:w-1/2 px-2">
                                    <v-text-field outlined prepend-inner-icon="person"
                                        v-model="updateItem.full_name"
                                        label="Name" readonly filled>
                                    </v-text-field>
                                    </div>

				<div class="w-full md:w-1/2 px-2">
                                   <v-select v-model="updateItem.term_cd" prepend-inner-icon="calendar_month"
                                                  :items="semesters"
                                                  label="Semester" outlined readonly chips filled>
                                   </v-select>
                                </div>	

                                    <div class="w-full md:w-1/2 px-2">
                                    <v-textarea outlined prepend-inner-icon="library_books" rows="3"
                                        v-model="updateItem.course_name"
                                        label="Course Name(s)" readonly filled>
                                    </v-textarea>
                                    </div>

				<div class="w-full md:w-1/3 px-2">
                                   <v-select v-model="updateItem.role" prepend-inner-icon="school"
                                                  :items="roles"
                                                  label="Role" outlined readonly chips filled>
                                   </v-select>
                                </div>	

				<div class="w-full md:w-1/3 px-2">
                                    <v-textarea required
                                        v-model="updateItem.reason" required outlined rows="3" prepend-inner-icon="article"
                                        label="Reason" readonly filled>
                                    </v-textarea>
                                </div>

				<div class="w-full md:w-1/3 px-2">
                                   <v-select v-model="updateItem.status" prepend-inner-icon="school"
                                                  :items="statuses"
                                                  label="Status" outlined readonly chips filled>
                                   </v-select>
                                </div>	

                                    <div class="w-full md:w-1/1 px-2">
                                    <v-text-field outlined prepend-inner-icon="person"
                                        v-model="updateItem.requestor_full_name"
                                        label="Requestor" readonly filled>
                                    </v-text-field>
                                    </div>

				<div class="w-full md:w-5/5 px-2">
                                    <v-textarea required
                                        v-model="updateItem.notes" required outlined rows="3" prepend-inner-icon="person"
                                        label="Notes">
                                    </v-textarea>
                                </div>

				<div class="w-full md:w-1/1 px-2">
				     <v-switch outlined prepend-inner-icon="person" v-model="updateItem.approved" label="Approved"></v-switch>
				</div>

                                </div>
                            </div>
    
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :loading="loadingUpdate" color="blue darken-1" @click="update(updateItem)">Save</v-btn>
                        <v-btn outlined color="error" @click="close_update">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

<v-dialog v-model="dialog_help" class="w-full md:w-1/2">
                <v-card>
                    <v-card-title>
                        <span class="headline">Roles Info:</span>
                        <v-spacer></v-spacer>
                        <v-divider vertical class="mx-4"></v-divider>
                        <v-icon @click="close_help">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-text>
<ul>
	<li>Tutor: People with this role have the same access to the course as 
	students, except that they cannot view quizzes. Tutors can interact with 
	students in the discussion board and Inbox Messages, as well as view and 
	interact with all groups. Tutors can also create discussion boards and 
	collaborations (Google and Microsoft docs). This role does not provide 
	access to the gradebook. FERPA training is required and will be verified 
	before the person is added. </li>
	<li>Learning Assistant: People with this role can add, edit, and delete all 
	course content, except for quizzes. Learning Assistants can interact with 
	students in discussions, Inbox Messages, and groups. This role does not 
	provide access to the gradebook. FERPA training is required and will be 
	verified before the person is added.</li>
	<li>TA: People with this role have nearly all the same permissions as an 
	instructor, including access to view and edit quizzes and grade student 
	work. Instructor actions that TAs cannot perform include: publish courses, 
	create or edit student groups, add or edit Canvas learning outcomes, submit 
	work on behalf of students, or view log in dates and times for students. 
	FERPA training is required and will be verified before the person is added.</li>
	<li>Incomplete Student: People with this role have the same privileges as 
	the student role. Instructors may complete this form for students with 
	grades of "incomplete" to finish their work in a current semester course. 
	Incomplete grade status will be verified before the student is enrolled. <br>
&nbsp;</li>
</ul>
 		    </v-card-text>
                </v-card>
            </v-dialog>

    <v-card> 
    <v-card-title>
    <h2>{{ ctitle }}</h2>
    <v-spacer></v-spacer>
    <v-select label="Select Columns to Display" :items="headers" v-model="filteredheaders" multiple return-object>
            <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.text }}</span>
            </v-chip>
            <span
              v-if="index === 1"
              class="grey--text caption"
            >(+{{ filteredheaders.length - 1 }} others)</span>
          </template>
            </v-select>
          <!-- </v-flex> -->
    
    <v-btn icon class="mx-0" @click="download">
      <v-icon title="Excel Download" color="green">save_alt</v-icon>
    </v-btn>
    
    <v-btn icon class="mx-0" @click="reset">
       <v-icon title="Reload" color="blue">refresh</v-icon>
    </v-btn>
    
    <v-text-field clearable v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
   
    <v-card-text>
                <div class="grid grid-cols-1 lg:grid-cols-1">
                    <label class="text-lg font-semibold">Filters:</label>
                    <v-select v-model="filterApproved" :items="filterApproved_statusItems" outlined
                              label="Load In Approved?"></v-select>
                </div>
    </v-card-text>

    <v-divider></v-divider>
    
    <v-data-table  :footer-props="{'items-per-page-options': [50,100,500,1000,5000]}"  :headers="filteredheaders" :loading=progress_bar_loading :items="filteredResults" :search="search" class="elevation-1" :options.sync="pagination" show-group-by  multi-sort>
    
    <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
    
        <template v-for="header in headers" v-slot:[`header.${header.value}`]="{ header }">
              <span> {{ header.text }} </span>
          <div v-if="headers_to_filter.includes(header.text)">
              <div v-if="filters.hasOwnProperty(header.value)">
                                    <v-autocomplete
                                        flat
                                        hide-details
                                        multiple
                                        attach
                                        chips
                                        full-width
                                        hide-no-data
                                        clearable
                                                     disable-lookup
                                        :items="columnValueList(header.value).sort()"
                                        v-model="filters[header.value]"
                                    >
                                                                  <template v-slot:selection="{ item, index }">
                          <v-chip v-if="index < 5">
                                                 <span> 
                            {{ item }} 
                          </span>
                                            </v-chip>
                                            <span v-if="index === 5" class="grey--text caption" > 
                          (+{{ filters[header.value].length - 5 }} others) 
                          </span>
                                        </template>
                                    </v-autocomplete>
                                </div>
                                </div>
        </template>
    
    
    <template v-slot:item.approved="{ item }">
            <span v-if="item.approved === true"><v-chip color="green" dark>Yes</v-chip></span><span v-else><v-chip color="orange" dark>No</v-chip></span>
    </template>

<template v-slot:item.lms_course_name_url="{ item }">
          <a :href="'https://uispringfield.instructure.com/courses/sis_course_id:' + item.lms_course_name" target="_blank">{{ `${item.lms_course_name}`  }}</a>
</template>
    
                        <template v-slot:item.action="{ item }">
                            <v-icon v-if="isAdmin" small color="teal" @click="showForm(item)" title="Edit" class="mr-2">mdi-pencil</v-icon>
                            <v-icon small color="pink" @click="deleteItem(item)" title="Delete">mdi-delete</v-icon>
                        </template>
    
    </v-data-table>
    
    </v-card>
      <v-snackbar v-model="snackbar" :timeout="5000" :color="snackcolor">
                {{ snacktext }}
                <v-btn color="white" text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    </template>
    
    <script>
    import XLSX from 'xlsx';
    
    export default {
            data() {
                    return {
    app_name: process.env.MIX_APP_NAME,
    validationErrors: '',
    search: this.search_value,
    fill:[],
    headers_to_filter: ['Name', 'Semester', 'Status', 'Role', 'Approved By', 'Requestor'],
    filteredheaderarray: [],
    headerarray:[],
    index: -1,
    progress_bar_loading: true,
                    snackbar: false,
                    snackcolor: '',
                    snacktext: '',
    dialog: false,
    dialog_add: false,
    dialog_update: false,
    dialog_help: false,
    loadingStore: false,
    loadingUpdate: false,
    crns:[],
    uins:[],
    searchcrn: '',
    searchuin: '',
    filterApproved: true,
    filterApproved_statusItems: [
                {text: 'Yes', value: false},
                {text: 'No', value: true},
            ],
    loadingData: false,
    defaultItem: {
                id: '',
                full_name: '',
                netid: '',
                uin: '',
                requestor_full_name: '',
                term_cd: '',
                crn: '',
                role: '',
                course_name: '',
                reason: '',
                status: '',
                notes: '',
                approved: '',
                approved_at: '',
                approved_by: '',
    },
    addedItem: {
                id: '',
                full_name: '',
                netid: '',
                uin: '',
                requestor_full_name: '',
                term_cd: '',
                crn: '',
                role: '',
                course_name: '',
                reason: '',
                status: '',
                notes: '',
                approved: '',
                approved_at: '',
                approved_by: '',
                
    },
    updateItem: {
                id: '',
                full_name: '',
                netid: '',
                uin: '',
                requestor_full_name: '',
                term_cd: '',
                crn: '',
                role: '',
                course_name: '',
                reason: '',
                status: '',
                notes: '',
                approved: '',
                approved_at: '',
                approved_by: '',
               
    },
semesters:[
{text: 'Fall 2024', value: '420248'},
{text: 'Spring 2025', value: '420251'},
{text: 'Summer 2025', value: '420255'},
{text: 'Fall 2025', value: '420258'},
],
roles:[
{text: 'Incomplete', value: 'Incomplete'},
{text: 'Learning Assistant', value: 'Learning Assistant'},
{text: 'Manual Teacher', value: 'Manual Teacher'},
{text: 'TA', value: 'ta'},
{text: 'Tutor', value: 'Tutor'},
{text: 'Unit Head', value: 'Unit Head'},
],
statuses:[
{text: 'Submitted', value: 'Submitted'},
{text: 'Approved', value: 'Approved'},
{text: 'Completed', value: 'Completed'},
],
    hide_headers:['lms_course_name'],
    rowsPerPageItems: [10,50,100,2000],
    headers: [
    { text: 'Actions', value: 'action', sortable: false, groupable: false, },
    { text: 'Approved', value: 'approved', sortable: true, groupable: true, filter: (value) => {
            if (!this.filterApproved)
                {
                    return true;
                }
            if (value == false)
                {
                    return true;
                }
            return false;
           }},
    { text: 'Name', value: 'full_name', sortable: true, groupable: false, width: 300,},
    { text: 'Netid', value: 'netid', sortable: true, groupable: false, },
    { text: 'UIN', value: 'uin', sortable: true, groupable: false, },
    { text: 'Requestor', value: 'requestor_full_name', sortable: true, groupable: false, width: 300,},
    { text: 'Semester', value: 'term_cd', sortable: true, groupable: false, width: 200,},
    { text: 'Role', value: 'role', sortable: true, groupable: false, width: 300,},
    { text: 'Course Name(s)', value: 'course_name', sortable: true, groupable: false, },
    { text: 'lms_course_name', value: 'lms_course_name', sortable: false, groupable: false, },
    { text: 'LMS Course Name(s)', value: 'lms_course_name_url', sortable: false, groupable: false, },
    { text: 'Reason', value: 'reason', sortable: true, groupable: false, },
    { text: 'Notes', value: 'notes', sortable: true, groupable: false, },
    { text: 'Status', value: 'status', sortable: true, groupable: false, width: 200,},
    { text: 'Approved By', value: 'approved_by', sortable: true, groupable: false, width: 300,},
    { text: 'Approved Date', value: 'approved_at', sortable: true, groupable: false, },
      ],
    
                    filters: {
    id:[],
    full_name:[],
    netid:[],
    uin:[],
    term_cd:[],
    crn:[],
    role:[],
    course_name:[],
    reason:[],
    notes:[],
    status:[],
    requestor_full_name:[],
    lms_course_name:[],
    approved:[],
    approved_by:[],
    approved_at:[],
                    },
                    selected:[],
                    pagination: {
    
                    },
    
                    Results:[],
                    dialog: false,
    
            }
            },
                 created () {
                         this.initialize()
                 },
    watch: {
                dialog (val) {
                    val || this.close()
                },
   searchcrn(val) {
                if (!val || val.length < 2) {
                    return
                }
                setTimeout(() => {
                    this.makeSearch(val, this);
                }, 200);
            },
   searchuin(val) {
                if (!val || val.length < 4) {
                    return
                }
                setTimeout(() => {
                    this.makeUinSearch(val, this);
                }, 200);
            },
            },
                   mounted() {
                           console.log('Indexall component mounted');
     },
    props: {
    ctitle: {
                 type: String,
                 required: true,
                                  },
    isAdmin: {
      type: Boolean,
      required: true,
    },
      },
           computed:{
                    filteredResults() {
                    return this.Results.filter(d => {
                            return Object.keys(this.filters).every(f => {
                                    return this.filters[f].length < 1 || this.filters[f].includes(d[f])
                            })
                    })
                    },
            filteredheaders: { 
                get(){
                return this.headers.filter((h) => !this.hide_headers.includes(h.value)); 
                },
                set(newval){
                this.headers = newval;
                }
            },
            unfilteredheaders: { 
                get(){
                return this.headers.filter((h) => this.hide_headers.includes(h.value)); 
                },
                set(newval){
                this.headers = newval;
                }
            }
           },
    
    methods:
           {
                    columnValueList(val) {
                            //console.log(val)
                            return this.Results.map(d => d[val])
                    },
                   initialize()
                   {
                            this.fetchApp()
                            this.filteredheaders = this.headers;
                   },
    
             async fetchApp(){
                           await axios.get('/' + this.app_name + '/api/v1/courseassistants')
                                   .then((response) => {
                                                   this.Results = (response.data);
                                                   this.progress_bar_loading = false;
                                                   })
                           .catch(error => {});
    
             },
    
              customFilter(items, search, filter) {
                        search = search.toString().toLowerCase();
                        this.fill = items.filter(i => (
                                                Object.keys(i).some(j => filter(i[j], search))
                                                ))
                                //console.log(this.fill);
                        return this.fill;
                },
            reset()
                         {
                         this.fetchApp();
                         },
                showForm: function (item) {
                    this.index = this.Results.indexOf(item);
                    this.updateItem = Object.assign({}, item);
                    this.dialog_update = true;
                },
	makeSearch: async (value, self) => {
                // Handle empty value
                if (!value) {
                    self.crns = [];
                    self.addedItem.crn = '';
                }
                // Items have already been requested
                if (self.loadingData) {
                    return
                }

                self.loadingData = true;

                // YOUR AJAX Methods go here
                // if you prefer not to use vue-api-query
                await axios.get('/' + self.app_name + '/api/v1/crnlookup/' + self.addedItem.term_cd, { params: { searchCrn: value },})
                    .then(response => {
                        self.crns = response.data
                    }).catch(error => {
		if(error.response.status === 401)
                    {
        		self.snackbar = true;
        		self.snackcolor = 'error';
        		self.snacktext = 'Unauthorized - Please close your browser and log in again.';
                    }

                    })
                    .finally(() => (self.loadingData = false))
            },
         makeUinSearch: async (value, self) => {
                // Handle empty value
                if (!value) {
                    self.uins = [];
                    self.addedItem.uin = '';
                }
                // Items have already been requested
                if (self.loadingData) {
                    return
                }

                self.loadingData = true;

                // YOUR AJAX Methods go here
                // if you prefer not to use vue-api-query
                await axios.get('/' + self.app_name + '/api/v1/adlookup', { params: { searchUin: value },})
                    .then(response => {
                        self.uins = response.data
                    }).catch(error => {
		if(error.response.status === 401)
                    {
        		self.snackbar = true;
        		self.snackcolor = 'error';
        		self.snacktext = 'Unauthorized - Please close your browser and log in again.';
                    }

                    })
                    .finally(() => (self.loadingData = false))
            },
    deleteItem: function(item) {
            if (confirm('Are you sure you want to delete this Course Assistant?') == true) {
            axios.delete('/' + this.app_name + '/api/v1/courseassistants/' + item.id)
                    .then(response => {
                if(response.status === 201 || response.status === 200) {
                        this.Results.splice(this.Results.indexOf(item), 1);
                this.snackbar = true;
                        this.snackcolor = 'success';
                        this.snacktext = 'The Course Assistant was removed successfully.';
                        }
                         else
                                {
                                    this.snackbar = true;
                                    this.snackcolor = 'error';
                                    this.snacktext = 'An error occurred.  The Course Assistant was not removed.';
                                }
                    })
	    }
    },
                close_add () {
                this.validationErrors = '';
                this.dialog_add = false
                this.addedItem = Object.assign({}, this.defaultItem);
            },
                close_update () {
                this.validationErrors = '';
                this.dialog_update = false
            },
	    close_help () {
		this.dialog_help = false
	    },
            async store(item) {
                await axios.post('/' + this.app_name + '/api/v1/courseassistants', item)
                    .then(response => {
                if(response.status === 201) {
                        this.Results.push(response.data);
                 this.snackbar = true;
                        this.snackcolor = 'success';
                        this.snacktext = 'Your Course Assistant has been been saved.';
                        this.close_add()
                }
             else
                    {
                                    this.loadingStore = false;
                                    this.close_add();
                    this.snackbar = true;
                    this.snackcolor = 'error';
                    this.snacktext = 'Your Course Assistant did NOT save.  Please logout and try again.';
                    }
                    })
         .catch((error) => {
                        // Error
                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            if (error.response.status == 422) {
                                this.snackbar = true;
                                this.snackcolor = 'error';
                                this.snacktext = 'Validation error.  See above.';
                                this.validationErrors = error.response.data.errors;
                            }
                else if (error.response.status == 401) {
                                this.snackbar = true;
                                this.snackcolor = 'error';
                                this.snacktext = 'Unauthorized - Please close your browser and log in again.';
                                this.validationErrors = "Unauthorized - Please close your browser and log in again.";
                            } 
                        } else if (error.request) {
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
    
                        } else {
                            // Something happened in setting up the request that triggered an Error
    
                        }
                                this.loadingStore = false;
                    })
        },
        async update(item) {	
                        if (this.index > -1) {
                            this.loadingUpdate = true;
    
                            await axios.put('/' + this.app_name + '/api/v1/courseassistants/' + item.id, item).then(response => {
                                if(response.status === 201 || response.status === 200) {
				    //console.log('data: ', response.data);
                                    Object.assign(this.Results[this.index], response.data);
                                    this.loadingUpdate = false;
                                    this.close_update();
    
                        this.snackbar = true;
                        this.snackcolor = 'success';
                        this.snacktext = 'Your Course Assistant has been updated.';
    
                                }
                    else
                    {
                                    this.loadingUpdate = false;
                                    this.close_update();
                    this.snackbar = true;
                    this.snackcolor = 'error';
                    this.snacktext = 'Your Course Assistant did NOT save.  Please logout and try again.';
                    }})
            .catch((error) => {
                        // Error
                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            if (error.response.status == 422) {
                                this.snackbar = true;
                                this.snackcolor = 'error';
                                this.snacktext = 'Validation error.  See above.';
                                this.validationErrors = error.response.data.errors;
                            }
                            else if (error.response.status == 401) {
                                this.snackbar = true;
                                this.snackcolor = 'error';
                                this.snacktext = 'Unauthorized - Please close your browser and log in again.';
                                this.validationErrors = "Unauthorized - Please close your browser and log in again.";
                            }
                        } else if (error.request) {
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
    
                        } else {
                            // Something happened in setting up the request that triggered an Error
    
                        }
                                this.loadingUpdate = false;
                    });
                        } else {
                            console.log('updated data');
                            console.log(this.updateItem);
                        }
                    
                },
        download() {
          var first_record_json;
          var all_headers;
          var first_record_json;
          var first_record_json_keys;
          var all_headers_not;
    
          var local_delete = [];
    
          this.filteredheaders.forEach(element => this.filteredheaderarray.push(element.value));
    
          //ADDED because it was a computed value (template v-slot) that would not go in the download
          this.unfilteredheaders.forEach(element => this.filteredheaderarray.push(element.value));
    
          this.headers.forEach(element => this.headerarray.push(element.value));
          first_record_json = this.Results[0];
    
          //console.log(first_record_json);
          first_record_json_keys  = Object.keys(first_record_json);
          all_headers_not = first_record_json_keys.filter(x=> !this.filteredheaderarray.includes(x));
          // console.log(all_headers_not);
          // local_delete = this.fill;
          local_delete = this.filteredResults; // change this when I figure out how the customFilter should work
          // console.log(this.filter_delete);
          for (var k =0;k<local_delete.length;k++)
          {
            for(var i=0;i<all_headers_not.length;i++)
            {
                    var key = all_headers_not[i];
                    delete local_delete[k][key];
            }
          }
          // console.log(this.filter_delete[0]);
          var work = XLSX.utils.json_to_sheet(local_delete);
          var new_workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(new_workbook, work, "SheetJS");
                            var date = new Date();
          XLSX.writeFile(new_workbook, this.app_name + '_app_export_' + date.getTime() + '.xlsx');
                            this.filteredheaderarray = [];
          this.headerarray = [];
        },
        BackgroundColor: function(tcourse, key) {
          var result = '';
          console.log('The key is ', key);
          if(key == 'approved')
                  {
                          if(tcourse.approved == 0)
                          {
                          result = 'badge p-2 h-3 font-weight-light badge-info'
                          }
                  else
              {
                result = 'badge p-2 font-weight-light badge-success'
              }
          }
    
          return result;
        },
    onEditorBlur(editor) {
          // console.log('editor blur!', editor)
        },
        onEditorFocus(editor) {
          // console.log('editor focus!', editor)
        },
        onEditorReady(editor, body = null) {},
        onEditorChange({ quill, html, text }) {
          // console.log('editor change!', quill, html, text)
          this.content = html;
        },
     }
    }
    </script>
    
